{
	"button.copy": "Copy",
	"button.email": "Email",
	"button.share": "Share",
	"button.sms": "SMS",
	"footer.poweredBy": "Powered by <linkText>Ice Cream Social<\/linkText>",
	"footer.privacyPolicy": "Privacy Policy",
	"footer.termsAndConditions": "Terms and Conditions",
	"offer.hint": "When {conversionGoal, plural, one {# friend makes a purchase} two {# friends make purchases} few {# friends make purchases} many {# friends make purchases} other {# friends make purchases}}, you'll receive your reward!",
	"optInMessage": "Let us know where to contact you with offer and reward updates. Unsubscribe anytime.",
	"order.confirmed": "Order #{orderId} confirmed!",
	"order.details": "See Order Details",
	"share.email.duplicateError": "Whoops! You already added that email.",
	"share.email.heading": "Invite friends by email",
	"share.email.inputLabel": "Friend's Email Address",
	"share.email.inputSubmit": "Enter",
	"share.email.invitesSubmit": "Send Invites",
	"share.email.moreOptions": "More Share Options",
	"share.email.subheading": "Enter your friends' email addresses below",
	"share.general.help": "<bold>Having trouble?<\/bold> Apps might not open if not installed on your device, try using <bold2>Share<\/bold2> by your personal link instead",
	"share.general.linkLabel": "Use your personal link to share anywhere",
	"share.general.otherOptions": "Or share now on these platforms",
	"thankyou.dismissCTA": "Dismiss",
	"thankyou.heading": "Thanks for sharing!",
	"thankyou.message": "You're a champ! We'll send you updates on your reward progress to your inbox.",
	"thankyou.reminder": "Keep in mind you can always revisit this offer later if you want to continue sharing.",
	"thankyou.shareCTA": "Continue Sharing",
	"unlock.consentExplanation": "We'll get in touch using the information you provided. You can unsubscribe at any time, but you might miss updates about your offer",
	"unlock.consentPolicyExplanation": "We protect your data with care, just as described in our <linkText>Privacy Policy<\/linkText>",
	"unlock.emailConsentOptIn": "Email me updates",
	"unlock.error.invalidEmail": "Please enter a valid email",
	"unlock.error.noConsent": "Please consent to email communications to participate in this offer",
	"unlock.input": "Your Email Address",
	"unlock.label": "Activate Offer",
	"share.general.copySuccess": "✨ Link copied!"
}